<div class="table-container">
    <table>
        <thead>
            <tr>
            <th>Player</th>
            <th class="center">Paid</th>
            <th class="narrow"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let p of field">
                <td>
                    {{ p.firstName }} {{ p.lastName }}
                </td>
                <td class="center">
                    <img class="has-paid-image" src="../../../../assets/noun-check-circle-6630733-71D358.png" *ngIf="p.hasPaid" />
                    <img class="has-paid-image" src="../../../../assets/noun-x-circle-4815624-FF001C.png" *ngIf="!p.hasPaid" />
                </td>
                <td class="narrow"><ui-switch [(ngModel)]="p.hasPaid" defaultBgColor="red" class="toggle-switch" (ngModelChange)="toggleHasPaid(p)"></ui-switch></td>
            </tr>
        </tbody>
    </table>
    <div *ngIf="!field || field.length === 0" class="empty-message">
        The field for this league is currently empty.
    </div>
</div>
